import Vue from 'vue';
import store from '../store';

/**
 * Simple API helper with explicit v1 and v2 methods
 */

// V1 API auth helper
function getV1Options(options = {}) {
    const token = store.getters['authentication/getV1Token'];
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};
    
    return {
        ...options,
        root: process.env.VUE_APP_API_ROOT,
        headers: { ...options.headers, ...authHeaders }
    };
}

// V2 API auth helper
function getV2Options(options = {}) {
    const token = store.getters['authentication/getV2Token'];
    const authHeaders = token ? { 'Authorization': `Bearer ${token}` } : {};
    
    return {
        ...options,
        root: process.env.VUE_APP_API_V2_ROOT,
        headers: { ...options.headers, ...authHeaders }
    };
}

const api = {
    // API v1 methods - use the original API
    v1: {
        get(endpoint, options = {}) {
            return Vue.http.get(endpoint, getV1Options(options));
        },
        
        post(endpoint, data, options = {}) {
            return Vue.http.post(endpoint, data, getV1Options(options));
        },
        
        put(endpoint, data, options = {}) {
            return Vue.http.put(endpoint, data, getV1Options(options));
        },
        
        delete(endpoint, options = {}) {
            return Vue.http.delete(endpoint, getV1Options(options));
        },
        
        patch(endpoint, data, options = {}) {
            return Vue.http.patch(endpoint, data, getV1Options(options));
        }
    },
    
    // API v2 methods - use the new API
    v2: {
        get(endpoint, options = {}) {
            return Vue.http.get(endpoint, getV2Options(options));
        },
        
        post(endpoint, data, options = {}) {
            return Vue.http.post(endpoint, data, getV2Options(options));
        },
        
        put(endpoint, data, options = {}) {
            return Vue.http.put(endpoint, data, getV2Options(options));
        },
        
        delete(endpoint, options = {}) {
            return Vue.http.delete(endpoint, getV2Options(options));
        },
        
        patch(endpoint, data, options = {}) {
            return Vue.http.patch(endpoint, data, getV2Options(options));
        }
    }
};

export default api;